import React from "react";
import './ServicesSection.css';
import relocationImage from "../assets/relocation.jpg";
import languageImage from "../assets/language.jpg";
import visaImage from "../assets/visa.jpg";
import jobImage from "../assets/job.jpg";
import { useTranslation } from 'react-i18next';

const ServicesSection = () => {
  const { t, i18n } = useTranslation();
  const isGerman = i18n.language === 'de';

  return (
    <section className="support-section" id="support">
      <div className="support-header">
        <h2 className="support-title">
          <span className="services-title-decor">{t('services_partner_title')}</span>
        </h2>
        <p className="support-subtitle">{t('services_tagline')}</p>
        <div className="support-intro-compact">
          <p className="intro-paragraph">{t('services_partner_desc1')}</p>
          <div className="support-intro-divider"></div>
          <p className="intro-paragraph">{t('services_partner_desc2')}</p>
        </div>
      </div>
      <div className="support-cards">
        <div className="support-card">
          <img src={jobImage} alt={isGerman ? "Zugang zum deutschen Markt" : "Accès au marché allemand"} className="support-icon" loading="lazy" decoding="async" />
          <h3 className="support-card-title job" style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 700,
            fontSize: '1.18rem',
            marginBottom: '0.7rem',
            textAlign: 'center'
          }}>
            {t('services_card1_title')}
          </h3>
          <div className="support-card-desc" style={{
            fontFamily: "'Montserrat', sans-serif",
            color: "#374151",
            fontSize: "1.06rem",
            textAlign: "center",
            margin: "0 auto",
            lineHeight: 1.7,
            maxWidth: 320
          }}>
            {t('services_card1_desc')}
          </div>
        </div>
        <div className="support-card">
          <img src={languageImage} alt={isGerman ? "Strategische Partnerschaften" : "Développement de partenariats stratégiques"} className="support-icon" loading="lazy" decoding="async" />
          <h3 className="support-card-title language" style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 700,
            fontSize: '1.18rem',
            marginBottom: '0.7rem',
            textAlign: 'center'
          }}>
            {t('services_card2_title')}
          </h3>
          <div className="support-card-desc" style={{
            fontFamily: "'Montserrat', sans-serif",
            color: "#374151",
            fontSize: "1.06rem",
            textAlign: "center",
            margin: "0 auto",
            lineHeight: 1.7,
            maxWidth: 320
          }}>
            {t('services_card2_desc')}
          </div>
        </div>
        <div className="support-card">
          <img src={visaImage} alt={isGerman ? "Brücken zwischen Ökosystemen" : "Création de passerelles entre deux écosystèmes"} className="support-icon" loading="lazy" decoding="async" />
          <h3 className="support-card-title visa" style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 700,
            fontSize: '1.18rem',
            marginBottom: '0.7rem',
            textAlign: 'center'
          }}>
            {t('services_card3_title')}
          </h3>
          <div className="support-card-desc" style={{
            fontFamily: "'Montserrat', sans-serif",
            color: "#374151",
            fontSize: "1.06rem",
            textAlign: "center",
            margin: "0 auto",
            lineHeight: 1.7,
            maxWidth: 320
          }}>
            {t('services_card3_desc')}
          </div>
        </div>
        <div className="support-card">
          <img src={relocationImage} alt={isGerman ? "Koordination und Begleitung" : "Coordination et accompagnement"} className="support-icon" loading="lazy" decoding="async" />
          <h3 className="support-card-title relocation" style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 700,
            fontSize: '1.18rem',
            marginBottom: '0.7rem',
            textAlign: 'center'
          }}>
            {t('services_card4_title')}
          </h3>
          <div className="support-card-desc" style={{
            fontFamily: "'Montserrat', sans-serif",
            color: "#374151",
            fontSize: "1.06rem",
            textAlign: "center",
            margin: "0 auto",
            lineHeight: 1.7,
            maxWidth: 320
          }}>
            {t('services_card4_desc')}
          </div>
        </div>
      </div>
      <div className="support-btn-wrapper">
        <button className="support-btn" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>{t('explore_services')}</button>
      </div>
    </section>
  );
};

export default ServicesSection;
